import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import React, { useState } from 'react';
import AppLink from '../components/common/AppLink/AppLink';
import ListHeader from '../components/ListHeader';
import PaginationBar from '../components/PaginationBar';
import { useSearchTerm } from '../hooks/useSearchTerm';
import { useSyncPageParams } from '../hooks/useSyncPageParams';
import { ROUTE_PATHS } from '../routes/Routes';
import { useGetAllUserRoles } from '../services/react-query/user_roles';
import { listPageTableRowStyling } from '../styles/sxStyling';
import { UserRole } from '../types/UserRole';
import { Loading } from '../uikit';
import TierModal from '../components/userRoles/TierModal';
import qs from 'qs';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';

const UserRolesList: React.FC = () => {
  const navigate = useNavigate();
  const { currentPage, setCurrentPage } = useSyncPageParams();
  const [showModal, setShowModal] = useState<boolean>(false);
  const { data, isLoading: isGetAllUserRoleLoading } = useGetAllUserRoles({
    params: {
      page: currentPage,
      search: useSearchTerm(),
    },
  });

  const userRoles = data?.data;
  const meta = data?.meta;
  const totalPages = Number(meta?.total_pages);

  if (isGetAllUserRoleLoading) {
    return <Loading />;
  }

  const newWithTier = (tierUuid: string) => {
    navigate(`./new?${qs.stringify({ tierUuid })}`);
  };

  const tableItems =
    userRoles &&
    userRoles.map((userRole: UserRole) => (
      <TableRow key={userRole.uuid} sx={{ ...listPageTableRowStyling }}>
        <TableCell>
          <AppLink to={`/${ROUTE_PATHS.USER_ROLES}/${userRole.uuid}`}>{userRole.name}</AppLink>
        </TableCell>
        <TableCell>{userRole.description}</TableCell>
      </TableRow>
    ));

  return (
    <Container>
      <ListHeader title="User Permissions" onNew={() => setShowModal(true)} />
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{tableItems}</TableBody>
        </Table>
      </TableContainer>
      {totalPages > 0 && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
          <PaginationBar page={currentPage} count={totalPages} onChange={(_e, v) => setCurrentPage(v)} />
        </Box>
      )}
      <TierModal isOpen={showModal} onCancel={() => setShowModal(false)} onCreate={newWithTier} />
    </Container>
  );
};

export default UserRolesList;
